import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { WEB_LINKS, LOGO, isRenault, LIBRARY_LINK } from '../util/constants'

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

// MUI icons
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CancelIcon from '@mui/icons-material/Cancel';
import GetAppIcon from '@mui/icons-material/GetApp';

// Redux Actions
import { showError } from './../redux/snackbar'
import { setLoading } from './../redux/loading'
import { initialStep } from './../redux/step'
import { removeForm } from './../redux/form'
import { removeVehicle } from './../redux/vehicle'
import { removeCustomer } from './../redux/customer'
import { removeVehicles } from './../redux/vehicles'
import { removeTimeSlots } from './../redux/timeSlots'
import { removeFormerDealer } from './../redux/formerDealer'


// Api Requests
import { cancelAppointment } from './../services/index'

// Custom
import CustomCard from './../components/CustomCard'
import { Typography } from '@mui/material';

// Spacing
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }

function FunctionalComponent(props) {

    // Props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const form = useSelector(state => state.form)
    const vehicle = useSelector(state => state.vehicle)
    const portLogin = useSelector(state => state.portLogin)

    const theme = useTheme();

    // Styles
    const styles = {
        formRoot: {
            width: '100%'
        },
        greenCheckIcon: {
            fill: theme.palette.success.main,
            width: '50px',
            height: '50px',
        },
        redCancelIcon: {
            fill: theme.palette.error.main,
            width: '50px',
            height: '50px',
        },
    }

    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingForm = useMemo(() => {

        const spacings = { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // Appoinment state
    const [isSuccess, setIsSuccess] = useState(true);

    //GA DataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formValidate',
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'formName': 'Online Servis Randevusu',
            'formType': 'service-request',
            'formCategory': 'lead-after-sales',
            'formStepName': 'step-5',
            'formStepNumber': 'step-5',
            'vehicleId': portLogin ? vehicle.id : "",

            'vehicleModel': portLogin ? vehicle.modelName : form.vehicleModel,

            'dealerName': form.dealer.name,
            'dealerId': form.dealer.id


        });
    }, [])



    // Cancel apppointment
    function handleCancelButton() {

        // Set loading
        dispatch(setLoading(true))

        // Send sms to customer and create appointment
        cancelAppointment()
            .then(() => {

                setIsSuccess(false)
            })
            .catch(e => {
                console.error(e)
                dispatch(showError(t('UNKNOWN_ERROR')))
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
    }

    // Return to start button
    function handleReturnButton() {

        // Clear redux
        dispatch(removeFormerDealer())
        dispatch(removeVehicles())
        dispatch(removeCustomer())
        dispatch(removeVehicle())
        dispatch(removeForm())
        dispatch(removeTimeSlots())

        // Go previous step
        dispatch(initialStep())

    }

    function getCardContent() {
        return (
            <form className={styles.formRoot} noValidate autoComplete="off">
                <Grid container spacing={spacingForm} justifyContent='center'>
                    <Grid item xs={12} container justifyContent='center'>
                        {isSuccess ? <DoneAllIcon sx={styles.greenCheckIcon} /> : <CancelIcon sx={styles.redCancelIcon} />}
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant='h6' color='textPrimary' align='center'>
                            {isSuccess ? t('appointmentSuccessMessage') : t('appointmentCancelMessage')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h6' color='textPrimary' align='center'>
                            {t('readQRCode')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent='center'>
                        <img alt="qr" src={LOGO.QR} width="250" height="250" />
                    </Grid>
                    <Grid item xs={12} container justifyContent='center' wrap='nowrap'>
                        <Button variant="contained" color='primary' style={{ width: '230px', minHeight: '42px', boxShadow: 'none', marginRight: '10px' }}
                            onClick={() => { window.open(WEB_LINKS.PORT, '_blank') }}>
                            {t('download')}
                            <GetAppIcon />
                        </Button>
                        <Button variant="contained" color='primary' style={{ width: '230px', minHeight: '42px', boxShadow: 'none', marginRight: '10px' }}
                            onClick={() => { window.open(`https://${t('renaultSiteAddress')}`, '_self') }}>
                            {t('renaultSiteAddress')}
                        </Button>
                    </Grid>
                    <Grid item xs={12} container justifyContent='center' wrap='nowrap'>
                        <Button variant="contained" color='primary' style={{ width: '230px', minHeight: '42px', boxShadow: 'none', marginRight: '10px' }}
                            onClick={() => { window.open(`http://${LIBRARY_LINK}`, '_blank') }}>
                            {t('maisLibrary')}
                        </Button>
                    </Grid>



                    {/* 
                    <Grid item xs={12} container justify='center'>
                        {
                            isSuccess ?
                            <Button
                                variant="outlined"
                                sx={styles.button}
                                onClick={handleCancelButton}
                                style={{minWidth: '105px'}}
                                color='error'
                            >
                                {t('cancelAppointmentButton')}
                            </Button>
                            :
                            <Button
                                variant="outlined"
                                sx={styles.button}
                                onClick={handleReturnButton}
                                style={{minWidth: '105px'}}
                                color='error'
                            >
                                {t('returnToHomeButton')}
                            </Button>
                        }
                    </Grid> */}

                </Grid>
            </form>
        );
    }

    function getCardActions() {
        return (
            <Box display='flex' justifyContent='flex-start'>

            </Box>
        )
    }

    return (
        <CustomCard
            padding={spacingRoot}
            content={getCardContent()}
            action={getCardActions()}
        />
    )

}

// Connect redux and translation
export default FunctionalComponent